<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        if (stuff.projects.length > 0) {
            return {
                redirect: `/${stuff.projects[0].uri}`,
                status: 301,
            };
        } else {
            console.warn('No Studio SH projects in load function!');
            return {};
        }
    };
</script>
